import { Pressable, Text, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { typography } from '@/src/theme/typography'

import { Icon, symbolName } from '../../../components/ui/Icon'

export function SessionScreenHeader({
  onClose,
  onOpenStepSelector,
  title,
}: {
  onClose: () => void
  onOpenStepSelector: () => void
  title: string
}) {
  return (
    <SafeAreaView className="bg-background-primary pt-2.5">
      <View className="flex-row items-center justify-between px-5 pb-2.5">
        <Pressable
          onPress={onOpenStepSelector}
          className="-ml-2 justify-center items-center"
          hitSlop={8}
          style={{ width: 28, height: 28 }}
        >
          <Icon
            name={symbolName('line.3.horizontal', 'menu')}
            size={22}
            color="black"
          />
        </Pressable>
        <Text
          className="flex-1 text-left ml-4"
          style={{ ...typography.label1 }}
        >
          {title}
        </Text>
        <Pressable
          onPress={onClose}
          className="-mr-1 justify-center items-center"
          hitSlop={8}
          style={{ width: 32, height: 32 }}
        >
          <Icon name={symbolName('xmark', 'close')} size={22} color="black" />
        </Pressable>
      </View>
    </SafeAreaView>
  )
}
